import React, { useCallback, useEffect, useState } from 'react'
import AudienceDetails from './AudienceDetails'
import AudienceSuccess from './AudienceSuccess'
import UploadAudience from './UploadAudience'
import AudienceSelectType from './AudienceSelectType'
import Modal from '../../components/Modal/Modal'
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router'

export type AudienceDetailsRef = {
  audience_name: string
  description: string
  filters: Record<string, unknown>
  audience_count: number
}

type AudienceDetailsType = {
  formValues?: Record<string, unknown>
  audience_id?: string
  audience_count?: number
}

const AddAudience = (): JSX.Element => {
  const navigate = useNavigate()
  const location = useLocation()
  const [audienceDetails, setAudienceDetails] = useState<AudienceDetailsType>({})
  const [audienceType, setAudienceType] = useState<
    'leads' | 'sales' | 'service' | 'custom' | undefined
  >(undefined)

  const onAudienceCreated = useCallback(
    (_audienceDetails) => {
      setAudienceDetails(_audienceDetails)
      navigate(`${audienceDetails.audience_id}/success`)
    },
    [audienceDetails.audience_id, navigate],
  )

  useEffect(() => {
    if (location.state) setAudienceDetails(location.state)
  }, [location.state])

  const onAudienceTypeSelected = useCallback(
    (_id: string, type: 'leads' | 'sales' | 'service' | 'custom') => {
      setAudienceType(type)
      navigate(`${_id}/details`)
    },
    [navigate],
  )

  return (
    <Modal modalRoute={true} isOpen={true} key={'AddAudience'}>
      <Routes>
        <Route
          path="select-type"
          element={<AudienceSelectType onAudienceTypeSelected={onAudienceTypeSelected} />}
        />
        <Route
          path=":audience_id/details"
          element={
            <AudienceDetails
              audienceType={audienceType ? audienceType : 'sales'}
              onAudienceCreated={onAudienceCreated}
            />
          }
        />
        <Route
          path=":audience_id/success"
          element={
            <AudienceSuccess
              onUploadAudiencePressed={() =>
                navigate(`${audienceDetails.audience_id}/deploy`)
              }
              audienceDetails={
                audienceDetails as {
                  audience_count?: number
                  formValues?: {
                    audience_name: string
                    description: string
                    customer_source_id: Array<{ label: string }>
                    vehicle_source: Array<{
                      Make: { label: string }
                      Model: { label: string }
                      Year: { label: string }
                    }>
                    customer_type: Array<{ label: string }>
                  }
                }
              }
            />
          }
        />
        <Route
          path=":audience_id/deploy"
          element={<UploadAudience audience_id={audienceDetails.audience_id} />}
        />
        <Route path="/" element={<Navigate to="select-type" replace />} />
      </Routes>
    </Modal>
  )
}

export default AddAudience
